class Loaders {

  constructor() {
    this.loader = '<img src="/wp-content/themes/hp-nyc-consumer/assets/images/snitch_transparent.gif">';
    this.snitchPath = "/wp-content/themes/hp-nyc-consumer/assets/images/snitch_transparent.gif";
  }

  static snitchTransparent() {
    return "/wp-content/themes/hp-nyc-consumer/assets/images/snitch_transparent.gif";
  }

  processing(text) {
    return "<div style='display: flex;justify-content: center; align-items: center; flex-direction: column;'><div style='text-align: center;'><img src='" + this.snitchPath + "'</div><div style='font-size: 2rem;'>" + text + "</div></div>";
  }

}
